import React from 'react'
// hooks
import { useCurrentUser } from 'hooks/useCurrentUser'
// components
import { ReduxInput } from 'components/FormElements'
import { InputAdornment } from '@mui/material'
// constants
import { CURRENCIES } from 'constants/currencies'
import { FORMAT_VALUES } from 'constants/objects'
// types
import { IField } from 'types/graphql'
import { CustomInputProps } from 'components/FormElements/Input'
// utils
import get from 'lodash/get'
import { maxValue, minValue, ValidatorFn } from 'utils/validators'

const getFieldAdornment = (format: string, currency: string): string => {
  if (format === FORMAT_VALUES.CURRENCY) {
    return CURRENCIES[currency].symbol
  }

  if (format === FORMAT_VALUES.NUMBER) {
    return '#'
  }
}

interface Props extends CustomInputProps {
  name?: string
  field: IField
  required?: boolean
  disabled?: boolean
  validate?: ValidatorFn
}

const ReduxNumberInput: React.FC<Props> = ({ name, field, disabled, required, validate, ...props }) => {
  const { company } = useCurrentUser()

  const minRange = get(field.settings, 'minRange')
  const maxRange = get(field.settings, 'maxRange')

  const validators = React.useMemo(() => {
    if (minRange || maxRange) {
      return [validate, minValue(minRange), maxValue(maxRange)].filter((validator) => validator)
    }
    return validate
  }, [validate, minRange, maxRange])

  const adornment = getFieldAdornment(get(field, 'format[0].value'), company?.currency || 'USD')

  return (
    <ReduxInput
      {...props}
      type={'number'}
      name={name || field.name}
      label={field.label}
      disabled={disabled}
      required={required}
      validate={validators}
      inputProps={{ step: 'any' }}
      startAdornment={adornment ? <InputAdornment position='start'>{adornment}</InputAdornment> : null}
    />
  )
}

export default ReduxNumberInput
